<script lang="ts">
	import { Toast, Toaster } from "toaster"
	import { Overlay } from "overlay"

	import { NavigationStore } from "../../stores/NavigationContext"
	import Sidebar from "../nav/Sidebar.svelte"
	import { ROUTES } from "./Routes"
	import { ContextMenu } from "context-menu"
	import { onMount } from "svelte"
	import { LatestVersion, ReleaseNotes } from "../../release-notes"
	import ShowLibrary from "./show-library/ShowLibrary.svelte"
	import MediaLibrary from "./media-library/MediaLibrary.svelte"
	import Schedule from "./schedule/Schedule.svelte"
	import { Tooltip } from "tooltip"
	import { openWhatsNewOverlay } from "../reusable/overlays/whats-new"
	import { ScheduleController } from "./schedule/ScheduleController"
	import { DataHandlerDevice, DataHandlerScene } from "luxedo-data"
	import ProjectorMenu from "./projectors/DeviceMenu.svelte"
	import PageNavigator from "../nav/PageNavigator.svelte"
	import TagColorPicker from "../reusable/tags/tag-color-picker/TagColorPicker.svelte"
	import LuxAi from "./lux-ai/LuxAI.svelte"

	let activeRoute: keyof typeof ROUTES = $state()

	NavigationStore.subscribe((route) => (activeRoute = route))

	function showWhatsNew() {
		const KEY = "last-visit-version"
		const visitedVersion = localStorage.getItem(KEY)

		if (!visitedVersion || visitedVersion != LatestVersion) {
			openWhatsNewOverlay()
			localStorage.setItem(KEY, LatestVersion)
		}
	}

	onMount(() => {
		if (!(activeRoute in ROUTES)) NavigationStore.set("show-library")

		console.log({ ScheduleController, DataHandlerDevice, DataHandlerScene })
		console.warn(`VERSION ${LatestVersion} LOADED`)

		setTimeout(() => {
			showWhatsNew()
		})
	})
</script>

<!-- chargebee checkout script -->
<svelte:head>
	<script
		src="https://js.chargebee.com/v2/chargebee.js"
		data-cb-site={import.meta.env.VITE_CHARGEBEE_SITE}
	></script>
</svelte:head>

<PageNavigator>
	{#if activeRoute === "projector"}
		<ProjectorMenu />
	{:else if activeRoute === "show-library"}
		<ShowLibrary />
	{:else if activeRoute === "media-library"}
		<MediaLibrary />
	{:else if activeRoute === "schedule"}
		<Schedule />
	{:else if activeRoute === "lux-ai"}
		<LuxAi />
	{:else}
		<h1>Page not found</h1>
	{/if}
</PageNavigator>

<TagColorPicker />
<Tooltip />
<Toaster topMargin={"1rem"} errorBackground="var(--red)" errorColor="var(--color-text-light)" />

<Overlay />
<ContextMenu />

<style>
</style>
